
import {Mixins, Component} from 'vue-property-decorator';
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";

@Component({})
export default class ExcelYuklemeCard extends Mixins(SimpleInputMixin) {

  fileRule(file: any) {
    if (file) {
      let uzanti = file.name.split('.').pop();
      if (["xls","xlsx", "XLS", "XLSX"].indexOf(uzanti) >= 0)
        return true;
      else
        return "Sadece xls dosya yüklenebilir.";
    } else
      return true;
  }

  downloadOrnekExcel() {
    window.open('/excel_ornek.xls')
  }
}
